import _slicedToArray from "/home/jenkins/jenkins_home/workspace/Efficience-dev/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectSpread from "/home/jenkins/jenkins_home/workspace/Efficience-dev/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _defineProperty from "/home/jenkins/jenkins_home/workspace/Efficience-dev/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
var _CODES_PREFIX;
import { js2xml, xml2js } from 'xml-js';
import { b64DecodeUnicode, b64EncodeUnicode } from "./dataUtils";
var CODES = {
  CIP: '1.2.250.1.215.200.1.1.1',
  UCD: '1.2.250.1.215.200.1.1.2',
  ATC: '1.2.250.1.215.200.1.2.1',
  ATC5: '1.2.250.1.215.200.1.2.2',
  CNAM: '1.2.250.1.215.200.1.3.1'
};
var CODES_PREFIX = (_CODES_PREFIX = {}, _defineProperty(_CODES_PREFIX, CODES.UCD, 'ucd'), _defineProperty(_CODES_PREFIX, CODES.CIP, 'cip'), _defineProperty(_CODES_PREFIX, CODES.ATC, 'atc'), _defineProperty(_CODES_PREFIX, CODES.ATC5, 'atc'), _defineProperty(_CODES_PREFIX, CODES.CNAM, 'cnam'), _CODES_PREFIX);
var translationToCode = function translationToCode(translation) {
  var _ref;
  var _translation$_attribu = translation['_attributes'],
    code = _translation$_attribu.code,
    displayName = _translation$_attribu.displayName,
    codeSystem = _translation$_attribu.codeSystem;
  return _ref = {}, _defineProperty(_ref, "".concat(CODES_PREFIX[codeSystem], "Code"), code), _defineProperty(_ref, "".concat(CODES_PREFIX[codeSystem], "Label"), displayName), _ref;
};
var parseRepresentedOrganization = function parseRepresentedOrganization() {
  var person = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _person$representedOr = person.representedOrganization,
    _person$representedOr2 = _person$representedOr === void 0 ? {} : _person$representedOr,
    _person$representedOr3 = _person$representedOr2.name,
    _person$representedOr4 = _person$representedOr3 === void 0 ? {} : _person$representedOr3,
    _person$representedOr5 = _person$representedOr4['_text'],
    esName = _person$representedOr5 === void 0 ? '' : _person$representedOr5,
    _person$representedOr6 = _person$representedOr2.id,
    _person$representedOr7 = _person$representedOr6 === void 0 ? {} : _person$representedOr6,
    _person$representedOr8 = _person$representedOr7._attributes,
    _person$representedOr9 = _person$representedOr8 === void 0 ? {} : _person$representedOr8,
    _person$representedOr10 = _person$representedOr9.extension,
    esId = _person$representedOr10 === void 0 ? '' : _person$representedOr10;
  return {
    es: {
      id: esId,
      name: esName
    }
  };
};
var parsePerson = function parsePerson() {
  var person = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _person$assignedPerso = person.assignedPerson,
    _person$assignedPerso2 = _person$assignedPerso === void 0 ? {} : _person$assignedPerso,
    _person$assignedPerso3 = _person$assignedPerso2.name,
    _person$assignedPerso4 = _person$assignedPerso3 === void 0 ? {} : _person$assignedPerso3,
    _person$assignedPerso5 = _person$assignedPerso4.given,
    _person$assignedPerso6 = _person$assignedPerso5 === void 0 ? {} : _person$assignedPerso5,
    _person$assignedPerso7 = _person$assignedPerso6['_text'],
    given = _person$assignedPerso7 === void 0 ? '' : _person$assignedPerso7,
    _person$assignedPerso8 = _person$assignedPerso4.family,
    _person$assignedPerso9 = _person$assignedPerso8 === void 0 ? {} : _person$assignedPerso8,
    _person$assignedPerso10 = _person$assignedPerso9['_text'],
    family = _person$assignedPerso10 === void 0 ? '' : _person$assignedPerso10;
  return _objectSpread({
    person: {
      name: family,
      given: given
    }
  }, parseRepresentedOrganization(person));
};
var getProfession = function getProfession(code, label) {
  var specialty;
  var formation;
  var profession;
  if (code.indexOf('/') !== -1) {
    var _code$split = code.split('/'),
      _code$split2 = _slicedToArray(_code$split, 2),
      splittedProf = _code$split2[0],
      splittedSpecialty = _code$split2[1];
    var _splittedProf$split = splittedProf.split('_'),
      _splittedProf$split2 = _slicedToArray(_splittedProf$split, 2),
      splittedFormation = _splittedProf$split2[0],
      splittedProfession = _splittedProf$split2[1];
    specialty = splittedSpecialty;
    formation = splittedFormation;
    profession = splittedProfession;
  } else if (code.indexOf('-') !== -1) {
    var _code$split3 = code.split('-'),
      _code$split4 = _slicedToArray(_code$split3, 2),
      _splittedProfession = _code$split4[0],
      _splittedSpecialty = _code$split4[1];
    specialty = _splittedSpecialty;
    profession = _splittedProfession;
  }
  return {
    professionCode: profession,
    professionLabel: label,
    formation: formation === 'G16',
    specialty: specialty
  };
};
var parsePerformer = function parsePerformer() {
  var performer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _performer$assignedEn = performer.assignedEntity,
    assignedEntity = _performer$assignedEn === void 0 ? {} : _performer$assignedEn,
    _performer$assignedEn2 = performer.assignedEntity,
    _performer$assignedEn3 = _performer$assignedEn2 === void 0 ? {} : _performer$assignedEn2,
    _performer$assignedEn4 = _performer$assignedEn3.id,
    _performer$assignedEn5 = _performer$assignedEn4 === void 0 ? {} : _performer$assignedEn4,
    _performer$assignedEn6 = _performer$assignedEn5._attributes,
    _performer$assignedEn7 = _performer$assignedEn6 === void 0 ? {} : _performer$assignedEn6,
    _performer$assignedEn8 = _performer$assignedEn7.extension,
    rpps = _performer$assignedEn8 === void 0 ? '' : _performer$assignedEn8,
    _performer$assignedEn9 = _performer$assignedEn3.code,
    _performer$assignedEn10 = _performer$assignedEn9 === void 0 ? {} : _performer$assignedEn9,
    _performer$assignedEn11 = _performer$assignedEn10['_attributes'],
    _performer$assignedEn12 = _performer$assignedEn11 === void 0 ? {} : _performer$assignedEn11,
    _performer$assignedEn13 = _performer$assignedEn12.code,
    performerProfessionCode = _performer$assignedEn13 === void 0 ? '' : _performer$assignedEn13,
    _performer$assignedEn14 = _performer$assignedEn12.displayName,
    performerProfessionLabel = _performer$assignedEn14 === void 0 ? '' : _performer$assignedEn14;
  return _objectSpread({
    rpps: rpps
  }, getProfession(performerProfessionCode, performerProfessionLabel), parsePerson(assignedEntity));
};
var parseAuthor = function parseAuthor() {
  var author = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _author$assignedAutho = author.assignedAuthor,
    assignedAuthor = _author$assignedAutho === void 0 ? {} : _author$assignedAutho,
    _author$assignedAutho2 = author.assignedAuthor,
    _author$assignedAutho3 = _author$assignedAutho2 === void 0 ? {} : _author$assignedAutho2,
    _author$assignedAutho4 = _author$assignedAutho3.id,
    _author$assignedAutho5 = _author$assignedAutho4 === void 0 ? {} : _author$assignedAutho4,
    _author$assignedAutho6 = _author$assignedAutho5._attributes,
    _author$assignedAutho7 = _author$assignedAutho6 === void 0 ? {} : _author$assignedAutho6,
    _author$assignedAutho8 = _author$assignedAutho7.extension,
    rpps = _author$assignedAutho8 === void 0 ? '' : _author$assignedAutho8,
    _author$assignedAutho9 = _author$assignedAutho3.code,
    _author$assignedAutho10 = _author$assignedAutho9 === void 0 ? {} : _author$assignedAutho9,
    _author$assignedAutho11 = _author$assignedAutho10['_attributes'],
    _author$assignedAutho12 = _author$assignedAutho11 === void 0 ? {} : _author$assignedAutho11,
    _author$assignedAutho13 = _author$assignedAutho12.code,
    professionCode = _author$assignedAutho13 === void 0 ? '' : _author$assignedAutho13,
    _author$assignedAutho14 = _author$assignedAutho12.displayName,
    professionLabel = _author$assignedAutho14 === void 0 ? '' : _author$assignedAutho14;
  return _objectSpread({
    rpps: rpps
  }, getProfession(professionCode, professionLabel), parsePerson(assignedAuthor));
};
var parsePerformerAuthor = function parsePerformerAuthor() {
  var entry = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    author: parseAuthor(entry.author),
    performer: parsePerformer(entry.performer)
  };
};
var parseREFR = function parseREFR() {
  var relation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _relation$supply = relation.supply,
    _relation$supply2 = _relation$supply === void 0 ? {} : _relation$supply,
    _relation$supply2$qua = _relation$supply2.quantity,
    _relation$supply2$qua2 = _relation$supply2$qua === void 0 ? {} : _relation$supply2$qua,
    _relation$supply2$qua3 = _relation$supply2$qua2['_attributes'],
    _relation$supply2$qua4 = _relation$supply2$qua3 === void 0 ? {} : _relation$supply2$qua3,
    quantity = _relation$supply2$qua4.value,
    _relation$supply2$per = _relation$supply2.performer,
    _relation$supply2$per2 = _relation$supply2$per === void 0 ? {} : _relation$supply2$per,
    _relation$supply2$per3 = _relation$supply2$per2.time,
    _relation$supply2$per4 = _relation$supply2$per3 === void 0 ? {} : _relation$supply2$per3,
    _relation$supply2$per5 = _relation$supply2$per4['_attributes'],
    _relation$supply2$per6 = _relation$supply2$per5 === void 0 ? {} : _relation$supply2$per5,
    date = _relation$supply2$per6.value;
  return _objectSpread({
    quantity: quantity,
    date: date
  }, parsePerformerAuthor(relation.supply));
};
var parseCOMP = function parseCOMP() {
  var relation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _relation$observation = relation.observation,
    _relation$observation2 = _relation$observation === void 0 ? {} : _relation$observation,
    _relation$observation3 = _relation$observation2.code['_attributes'],
    _relation$observation4 = _relation$observation3 === void 0 ? {} : _relation$observation3,
    code = _relation$observation4.code,
    _relation$observation5 = _relation$observation2.value['_attributes'],
    _relation$observation6 = _relation$observation5 === void 0 ? {} : _relation$observation5,
    value = _relation$observation6.value;
  if (['GEN-173', 'GEN-174'].includes(code)) {
    return {
      hospitalStayDelivered: value
    };
  } else if (code === 'MED-559') {
    return {
      unconditioned: value
    };
  }
};
var parseEntryRelationShip = function parseEntryRelationShip() {
  var entry = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _entry$_attributes = entry['_attributes'],
    _entry$_attributes2 = _entry$_attributes === void 0 ? {} : _entry$_attributes,
    typeCode = _entry$_attributes2.typeCode;
  switch (typeCode) {
    case 'REFR':
      return parseREFR(entry);
    case 'COMP':
      {
        return parseCOMP(entry);
      }
  }
};
var parseDM = function parseDM() {
  var section = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var entries = section.entry;
  if (!Array.isArray(entries)) {
    entries = [section.entry];
  }
  return entries.reduce(function (result, entry) {
    var _entry$supply = entry.supply,
      _entry$supply2 = _entry$supply === void 0 ? {} : _entry$supply,
      _entry$supply2$partic = _entry$supply2.participant,
      _entry$supply2$partic2 = _entry$supply2$partic === void 0 ? {} : _entry$supply2$partic,
      _entry$supply2$partic3 = _entry$supply2$partic2.participantRole,
      _entry$supply2$partic4 = _entry$supply2$partic3 === void 0 ? {} : _entry$supply2$partic3,
      _entry$supply2$partic5 = _entry$supply2$partic4.playingDevice,
      _entry$supply2$partic6 = _entry$supply2$partic5 === void 0 ? {} : _entry$supply2$partic5,
      _entry$supply2$partic7 = _entry$supply2$partic6.code,
      _entry$supply2$partic8 = _entry$supply2$partic7 === void 0 ? {} : _entry$supply2$partic7,
      _entry$supply2$partic9 = _entry$supply2$partic8['_attributes'],
      _entry$supply2$partic10 = _entry$supply2$partic9 === void 0 ? {} : _entry$supply2$partic9,
      _entry$supply2$partic11 = _entry$supply2$partic10.code,
      code = _entry$supply2$partic11 === void 0 ? '' : _entry$supply2$partic11,
      _entry$supply2$partic12 = _entry$supply2$partic10.displayName,
      displayName = _entry$supply2$partic12 === void 0 ? '' : _entry$supply2$partic12,
      _entry$supply2$partic13 = _entry$supply2$partic10.codeSystemName,
      codeSystemName = _entry$supply2$partic13 === void 0 ? '' : _entry$supply2$partic13,
      _entry$supply2$entryR = _entry$supply2.entryRelationship,
      entryRelationship = _entry$supply2$entryR === void 0 ? {} : _entry$supply2$entryR;
    if (codeSystemName !== 'Wolf') {
      var dm = {
        code: code,
        label: displayName
      };
      Object.assign(dm, parseREFR(entry));
      Object.assign(dm, parseEntryRelationShip(entryRelationship));
      result.push(dm);
    }
    return result;
  }, []);
};
var parseMedicaments = function parseMedicaments() {
  var section = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var entries = section.entry;
  if (!Array.isArray(entries)) {
    entries = [section.entry];
  }
  return entries.reduce(function (result, entry) {
    var _entry$substanceAdmin = entry.substanceAdministration,
      manufacturedMaterial = _entry$substanceAdmin.consumable.manufacturedProduct.manufacturedMaterial,
      _entry$substanceAdmin2 = _entry$substanceAdmin.entryRelationship,
      entryRelationship = _entry$substanceAdmin2 === void 0 ? [] : _entry$substanceAdmin2;
    var _manufacturedMaterial = manufacturedMaterial.code,
      _manufacturedMaterial2 = _manufacturedMaterial === void 0 ? {} : _manufacturedMaterial,
      _manufacturedMaterial3 = _manufacturedMaterial2.translation,
      translation = _manufacturedMaterial3 === void 0 ? [] : _manufacturedMaterial3,
      _manufacturedMaterial4 = _manufacturedMaterial2['_attributes'],
      _manufacturedMaterial5 = _manufacturedMaterial4 === void 0 ? {} : _manufacturedMaterial4,
      _manufacturedMaterial6 = _manufacturedMaterial5.codeSystemName,
      codeSystemName = _manufacturedMaterial6 === void 0 ? '' : _manufacturedMaterial6;
    var translations = translation;
    if (!Array.isArray(translations)) {
      translations = [translation];
    }
    var entryRelationships = entryRelationship;
    if (!Array.isArray(entryRelationships)) {
      entryRelationships = [entryRelationship];
    }
    if (codeSystemName !== 'Wolf') {
      var medicament = {};
      translations.forEach(function (trans) {
        if (trans.translation) {
          if (Array.isArray(trans.translation)) {
            Object.assign(medicament, {
              ingredients: trans.translation.map(function (t) {
                return translationToCode(t);
              })
            });
          } else {
            Object.assign(medicament, {
              ingredients: [translationToCode(trans.translation)]
            });
          }
        } else {
          Object.assign(medicament, translationToCode(trans));
          Object.assign(medicament, {
            label: medicament.cipLabel || medicament.ucdLabel
          });
        }
      });
      entryRelationships.forEach(function (rel) {
        return Object.assign(medicament, parseEntryRelationShip(rel));
      });
      result.push(medicament);
    }
    return result;
  }, []);
};
var parseHospital = function parseHospital() {
  var section = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var entries = section.entry;
  if (!Array.isArray(entries)) {
    entries = [section.entry];
  }
  return entries.reduce(function (result, entry) {
    var _entry$encounter = entry.encounter,
      _entry$encounter2 = _entry$encounter === void 0 ? {} : _entry$encounter,
      _entry$encounter2$cod = _entry$encounter2.code,
      _entry$encounter2$cod2 = _entry$encounter2$cod === void 0 ? {} : _entry$encounter2$cod,
      _entry$encounter2$cod3 = _entry$encounter2$cod2.qualifier,
      _entry$encounter2$cod4 = _entry$encounter2$cod3 === void 0 ? {} : _entry$encounter2$cod3,
      _entry$encounter2$cod5 = _entry$encounter2$cod4.value,
      _entry$encounter2$cod6 = _entry$encounter2$cod5 === void 0 ? {} : _entry$encounter2$cod5,
      _entry$encounter2$cod7 = _entry$encounter2$cod6['_attributes'],
      _entry$encounter2$cod8 = _entry$encounter2$cod7 === void 0 ? {} : _entry$encounter2$cod7,
      _entry$encounter2$cod9 = _entry$encounter2$cod8.code,
      code = _entry$encounter2$cod9 === void 0 ? '' : _entry$encounter2$cod9,
      _entry$encounter2$cod10 = _entry$encounter2$cod8.displayName,
      displayName = _entry$encounter2$cod10 === void 0 ? '' : _entry$encounter2$cod10,
      _entry$encounter2$cod11 = _entry$encounter2$cod2['_attributes'],
      _entry$encounter2$cod12 = _entry$encounter2$cod11 === void 0 ? {} : _entry$encounter2$cod11,
      _entry$encounter2$cod13 = _entry$encounter2$cod12.codeSystemName,
      codeSystemName = _entry$encounter2$cod13 === void 0 ? '' : _entry$encounter2$cod13,
      _entry$encounter2$eff = _entry$encounter2.effectiveTime,
      _entry$encounter2$eff2 = _entry$encounter2$eff === void 0 ? {} : _entry$encounter2$eff,
      _entry$encounter2$eff3 = _entry$encounter2$eff2.low,
      _entry$encounter2$eff4 = _entry$encounter2$eff3 === void 0 ? {} : _entry$encounter2$eff3,
      _entry$encounter2$eff5 = _entry$encounter2$eff4['_attributes'],
      _entry$encounter2$eff6 = _entry$encounter2$eff5 === void 0 ? {} : _entry$encounter2$eff5,
      _entry$encounter2$eff7 = _entry$encounter2$eff6.value,
      from = _entry$encounter2$eff7 === void 0 ? '' : _entry$encounter2$eff7,
      _entry$encounter2$eff8 = _entry$encounter2$eff2.high,
      _entry$encounter2$eff9 = _entry$encounter2$eff8 === void 0 ? {} : _entry$encounter2$eff8,
      _entry$encounter2$eff10 = _entry$encounter2$eff9['_attributes'],
      _entry$encounter2$eff11 = _entry$encounter2$eff10 === void 0 ? {} : _entry$encounter2$eff10,
      _entry$encounter2$eff12 = _entry$encounter2$eff11.value,
      to = _entry$encounter2$eff12 === void 0 ? '' : _entry$encounter2$eff12,
      _entry$encounter2$per = _entry$encounter2.performer,
      _entry$encounter2$per2 = _entry$encounter2$per === void 0 ? {} : _entry$encounter2$per,
      _entry$encounter2$per3 = _entry$encounter2$per2.assignedEntity,
      assignedEntity = _entry$encounter2$per3 === void 0 ? {} : _entry$encounter2$per3;
    if (codeSystemName !== 'Wolf') {
      result.push({
        code: code,
        label: displayName,
        from: from,
        to: to,
        performer: parseRepresentedOrganization(assignedEntity)
      });
    }
    return result;
  }, []);
};
var parseMedicalCaresProcedure = function parseMedicalCaresProcedure() {
  var entry = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _entry$procedure = entry.procedure,
    _entry$procedure2 = _entry$procedure === void 0 ? {} : _entry$procedure,
    _entry$procedure2$cod = _entry$procedure2.code,
    _entry$procedure2$cod2 = _entry$procedure2$cod === void 0 ? {} : _entry$procedure2$cod,
    _entry$procedure2$cod3 = _entry$procedure2$cod2['_attributes'],
    _entry$procedure2$cod4 = _entry$procedure2$cod3 === void 0 ? {} : _entry$procedure2$cod3,
    _entry$procedure2$cod5 = _entry$procedure2$cod4.code,
    code = _entry$procedure2$cod5 === void 0 ? '' : _entry$procedure2$cod5,
    _entry$procedure2$cod6 = _entry$procedure2$cod4.displayName,
    displayName = _entry$procedure2$cod6 === void 0 ? '' : _entry$procedure2$cod6,
    _entry$procedure2$eff = _entry$procedure2.effectiveTime,
    _entry$procedure2$eff2 = _entry$procedure2$eff === void 0 ? {} : _entry$procedure2$eff,
    _entry$procedure2$eff3 = _entry$procedure2$eff2['_attributes'],
    _entry$procedure2$eff4 = _entry$procedure2$eff3 === void 0 ? {} : _entry$procedure2$eff3,
    effectivetime = _entry$procedure2$eff4.value,
    entryRelationship = _entry$procedure2.entryRelationship;
  return _objectSpread({
    code: code,
    label: displayName,
    date: effectivetime
  }, parseEntryRelationShip(entryRelationship));
};
var parseMedicalCares = function parseMedicalCares() {
  var section = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var entries = section.entry;
  if (!Array.isArray(entries)) {
    entries = [section.entry];
  }
  return entries.reduce(function (result, entry) {
    var _entry$procedure3 = entry.procedure,
      _entry$procedure4 = _entry$procedure3 === void 0 ? {} : _entry$procedure3,
      _entry$procedure4$cod = _entry$procedure4.code,
      _entry$procedure4$cod2 = _entry$procedure4$cod === void 0 ? {} : _entry$procedure4$cod,
      _entry$procedure4$cod3 = _entry$procedure4$cod2['_attributes'],
      _entry$procedure4$cod4 = _entry$procedure4$cod3 === void 0 ? {} : _entry$procedure4$cod3,
      _entry$procedure4$cod5 = _entry$procedure4$cod4.codeSystemName,
      codeSystemName = _entry$procedure4$cod5 === void 0 ? '' : _entry$procedure4$cod5,
      _entry$procedure4$per = _entry$procedure4.performer,
      performer = _entry$procedure4$per === void 0 ? {} : _entry$procedure4$per;
    if (codeSystemName !== 'Wolf') {
      result.push(_objectSpread({
        performer: parsePerformer(performer)
      }, parseMedicalCaresProcedure(entry)));
    }
    return result;
  }, []);
};
var parseBio = function parseBio() {
  var section = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var entries = section.entry;
  if (!Array.isArray(entries)) {
    entries = [section.entry];
  }
  return entries.reduce(function (result, entry) {
    var _entry$procedure5 = entry.procedure,
      _entry$procedure6 = _entry$procedure5 === void 0 ? {} : _entry$procedure5,
      _entry$procedure6$cod = _entry$procedure6.code,
      _entry$procedure6$cod2 = _entry$procedure6$cod === void 0 ? {} : _entry$procedure6$cod,
      _entry$procedure6$cod3 = _entry$procedure6$cod2['_attributes'],
      _entry$procedure6$cod4 = _entry$procedure6$cod3 === void 0 ? {} : _entry$procedure6$cod3,
      _entry$procedure6$cod5 = _entry$procedure6$cod4.codeSystemName,
      codeSystemName = _entry$procedure6$cod5 === void 0 ? '' : _entry$procedure6$cod5,
      _entry$procedure6$per = _entry$procedure6.performer,
      performer = _entry$procedure6$per === void 0 ? [] : _entry$procedure6$per;
    if (codeSystemName !== 'Wolf') {
      var _performer = _slicedToArray(performer, 2),
        labo = _performer[0],
        es = _performer[1];
      var laboInfo = parseRepresentedOrganization(labo.assignedEntity);
      var esInfo = parseRepresentedOrganization(es.assignedEntity);
      result.push(_objectSpread({
        performer: {
          person: {
            name: laboInfo && laboInfo.es ? laboInfo.es.name : ''
          },
          es: esInfo.es ? esInfo.es : {
            id: '',
            name: ''
          }
        }
      }, parseMedicalCaresProcedure(entry)));
    }
    return result;
  }, []);
};
export var parseHrDocument = function parseHrDocument(xml) {
  try {
    var result = xml2js(xml, {
      compact: true
    });
    var _result$ClinicalDocum = result.ClinicalDocument,
      _result$ClinicalDocum2 = _result$ClinicalDocum === void 0 ? {} : _result$ClinicalDocum,
      _result$ClinicalDocum3 = _result$ClinicalDocum2.component,
      _result$ClinicalDocum4 = _result$ClinicalDocum3 === void 0 ? {} : _result$ClinicalDocum3,
      _result$ClinicalDocum5 = _result$ClinicalDocum4.structuredBody,
      _result$ClinicalDocum6 = _result$ClinicalDocum5 === void 0 ? {} : _result$ClinicalDocum5,
      _result$ClinicalDocum7 = _result$ClinicalDocum6.component,
      component = _result$ClinicalDocum7 === void 0 ? [] : _result$ClinicalDocum7;
    var components = component;
    if (!Array.isArray(components)) {
      components = [component];
    }
    var sections = {};
    components.forEach(function (comp) {
      var _comp$section = comp.section,
        _comp$section$title = _comp$section.title,
        _comp$section$title2 = _comp$section$title === void 0 ? {} : _comp$section$title,
        _comp$section$title2$ = _comp$section$title2['_text'],
        title = _comp$section$title2$ === void 0 ? '' : _comp$section$title2$,
        _comp$section$code = _comp$section.code,
        _comp$section$code2 = _comp$section$code === void 0 ? {} : _comp$section$code,
        _comp$section$code2$_ = _comp$section$code2['_attributes'],
        _comp$section$code2$_2 = _comp$section$code2$_ === void 0 ? {} : _comp$section$code2$_,
        _comp$section$code2$_3 = _comp$section$code2$_2.code,
        code = _comp$section$code2$_3 === void 0 ? '' : _comp$section$code2$_3,
        _comp$section$code2$t = _comp$section$code2.translation,
        _comp$section$code2$t2 = _comp$section$code2$t === void 0 ? {} : _comp$section$code2$t,
        _comp$section$code2$t3 = _comp$section$code2$t2['_attributes'],
        _comp$section$code2$t4 = _comp$section$code2$t3 === void 0 ? {} : _comp$section$code2$t3,
        _comp$section$code2$t5 = _comp$section$code2$t4.code,
        subCode = _comp$section$code2$t5 === void 0 ? '' : _comp$section$code2$t5;
      switch (code) {
        case "10160-0":
          // Traitements
          sections['prescriptions'] = {
            code: code,
            title: title,
            values: parseMedicaments(comp.section)
          };
          break;
        case "11369-6":
          // Vaccinations
          sections['vaccinations'] = {
            code: code,
            title: title,
            values: parseMedicaments(comp.section)
          };
          break;
        case "46264-8":
          // Dispositif médicaux
          sections['medicalDevices'] = {
            code: code,
            title: title,
            values: parseDM(comp.section)
          };
          break;
        case "46240-8":
          // Hospitalisations
          sections['hospitalStays'] = {
            code: code,
            title: title,
            values: parseHospital(comp.section)
          };
          break;
        case "29554-3":
          // Actes
          switch (subCode) {
            case "67803-7":
              sections['medicalCares'] = {
                code: code,
                title: title,
                values: parseMedicalCares(comp.section)
              };
              break;
            case "18726-0":
              // Radiologie
              sections['radio'] = {
                code: code,
                title: title,
                values: parseMedicalCares(comp.section)
              };
              break;
            case "26436-6":
              // Biologie
              sections['bio'] = {
                code: code,
                title: title,
                values: parseBio(comp.section)
              };
              break;
          }
          break;
      }
    });
    return sections;
  } catch (e) {
    console.log('issue when parsing cda', e);
    return {
      error: {
        error: e.message,
        document: xml
      }
    };
  }
};
export var hasCustomStyleSheetApplied = function hasCustomStyleSheetApplied(cdaContentBase64) {
  try {
    var xml = b64DecodeUnicode(cdaContentBase64);
    var _xml2js = xml2js(xml, {
        compact: true
      }),
      stylesheet = _xml2js['xsl:stylesheet'],
      ClinicalDocument = _xml2js.ClinicalDocument;
    return !!stylesheet && !ClinicalDocument;
  } catch (e) {}
  return false;
};
export var extractStructuredBody = function extractStructuredBody(cdaContentBase64) {
  var xml = b64DecodeUnicode(cdaContentBase64);
  var _xml2js2 = xml2js(xml, {
      compact: true
    }),
    _xml2js2$ClinicalDocu = _xml2js2.ClinicalDocument,
    _xml2js2$ClinicalDocu2 = _xml2js2$ClinicalDocu === void 0 ? {} : _xml2js2$ClinicalDocu,
    component = _xml2js2$ClinicalDocu2.component;
  var cdaBody = js2xml({
    component: component
  }, {
    compact: true
  });
  return b64EncodeUnicode(cdaBody);
};